import { MedicalDataEarnRewardsPage } from "./medicalDataEarnRewards";

export const MedicalDataEarnRewards = MedicalDataEarnRewardsPage;
